import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn, OneToMany } from "typeorm";
import { DpomChildEntity } from "./dpom-child.entity";
import { PoBomEntity } from "../../po-bom/entittes/po-bom.entity";

@Entity('ppm_data')
export class PPMDataEntity {
    @PrimaryGeneratedColumn('increment', {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        name: "document_date",
        length:10
    })
    documentDate: string;

    @Column('varchar', {
        name: "po_number",
        length: 20,
    })
    purchaseOrderNumber: string;

    @Column('int', {
        name: "po_line_item_number",
    })
    poLineItemNumber: number;

    @Column("varchar", {
        name: "style_number",
        length: 10,
        nullable: true
    })
    styleNumber: string;

    @Column("varchar", {
        name: "product_code",
        length: 15,
        nullable: true
    })
    productCode: string;

    @Column("varchar", {
        name: "color_desc",
        length: 50,
        nullable: true
    })
    colorDesc: string;

    @Column("varchar", {
        name: "destination_country",
        length: 15,
        nullable: true
    })
    destinationCountry: string;

    @Column("varchar", {
        name: "plant",
        length: 10,
        nullable: true
    })
    plant: string;

    @Column("varchar", {
        name: "direct_ship_so_no",
        length: 15,
        nullable: true
    })
    directShipSONumber: string;

    @Column("varchar", {
        name: "direct_ship_so_item_no",
        length: 10,
        nullable: true
    })
    directShipSOItemNumber: string;

    @Column("varchar", {
        name: "customer_po",
        length: 50,
        nullable: true
    })
    customerPO: string;

    @Column("varchar", {
        name: "ship_to_customer_no",
        length: 15,
        nullable: true
    })
    shipToCustomerNumber: string;

    @Column("varchar", {
        name: "ship_to_customer_name",
        length: 50,
        nullable: true
    })
    shipToCustomerName: string;

    @Column("varchar", {
        name: "planning_season_code",
        length: 5,
        nullable: true
    })
    planningSeasonCode: string;

    @Column("varchar", {
        name: "planning_season_year",
        length: 5,
        nullable: true
    })
    planningSeasonYear: string;

    @Column("varchar", {
        name: "ogac",
        length: 10,
        nullable: true
    })
    OGAC: string;

    @Column("varchar", {
        name: "gac",
        length: 10,
        nullable: true
    })
    GAC: string;

    @Column("varchar", {
        name: "shipping_type",
        length: 30,
        nullable: true
    })
    shippingType: string;

    @Column("varchar", {
        name: "dpom_item_line_status",
        length: 15,
        nullable: true
    })
    DPOMLineItemStatus: string;

    @Column("varchar", {
        name: "inventory_segment_code",
        length: 10,
        nullable: true
    })
    inventorySegmentCode: string;

    @Column("varchar", {
        name: "total_item_qty",
        length: 10,
        nullable: true
    })
    totalItemQty: string;

    @Column("varchar", {
        name: "vas_size",
        length: 100,
        nullable: true
    })
    VASSize: string;

    @Column("int", {
        name: "size_qty",
        nullable: true
    })
    sizeQuantity: number;

    @Column("varchar", {
        name: "size_description",
        length: 10,
        nullable: true
    })
    sizeDescription: string;

    @Column("varchar", {
        name: "geo_code",
        length: 10,
        nullable: true
    })
    geoCode: string;

    @Column("varchar", {
        name: "gender_age_desc",
        length: 15,
        nullable: true
    })
    genderAgeDesc: string;

    @Column("text", {
        name: "item_vas_text",
        nullable: true
    })
    itemVasText: string;

    @Column("varchar", {
        name: "product_name",
        length: 50,
        nullable: true
    })
    productName: string;

    // CRM Data
    @Column('varchar', {
        name: "item",
        length: 10,
        nullable: true
    })
    item: string;

    @Column("varchar", {
        name: "po_and_line",
        length: 20,
        nullable: true
    })
    poAndLine: string;

    @Column("varchar", {
        name: "bom_item",
        length: 10,
        nullable: true
    })
    bomItem: string;

    @Column("int", {
        name: "od_version"
    })
    odVersion: number;

    @CreateDateColumn({
        name: "created_at",
    })
    createdAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user",
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
    })
    updatedAt: string;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user",
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag",
    })
    versionFlag: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;

    @Column('int', {
        nullable: true,
        name: 'file_id',
    })
    fileId: number;

    @Column({
        name: "is_bom_generated",
        default: 0
    })
    isBomGenerated: boolean;

    @OneToMany(type => PoBomEntity,poBom =>poBom.dpom)
    poBom:PoBomEntity

}
